module.exports = __webpack_public_path__ + "static/media/step2.73048c79.png";